import { Container, Card, Row, Col } from "react-bootstrap";

import React, { useContext, useEffect, useState } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import BackToTopButton from "../component/BackToTopButton";
import FeedbackWidget from "../component/FeedbackWidget";
import { useCurrUserUtility } from "../contexts/useCurrUserUtility";

export interface LayoutProps {
    children?: any,
    breadcrumList?: any,
    pageTitle?: string
}

const Layout = ({
    children,
    breadcrumList,
    pageTitle
}: LayoutProps) => {
    //workaround so footer goes all the way to the bottom without background being all black on load
    document.body.className = "app-background";
      const { isAuth } = useCurrUserUtility();

    return (
        <>
            <main id="main" className="main-wrapper" role="main"> 
                <Header></Header> 
                {/* Overlay Start */}
                <div className="overlay"></div>
                {/* Overlay End */}
                <div className="main-container">
                    {children}
                </div>
            </main>

            <Footer />
            <BackToTopButton />

            {isAuth() &&<FeedbackWidget />}
        </>
    );
};

export default Layout;
